module.exports = __webpack_public_path__ + "static/media/trek.34e73f38.png";